import { Appearance, Alert as NAlert, type Props as NAlertProps } from '@natera/material/lib/alert'
import { cn } from '~/shared/lib/cn'
import './alert.scss'

type AppearanceType = keyof typeof Appearance

interface AlertProps extends Omit<NAlertProps, 'appearance'> {
  className?: string
  appearance: AppearanceType
}

export function Alert({ children, className, appearance, ...rest }: AlertProps) {
  return (
    <NAlert
      {...rest}
      className={cn('c-alert', className)}
      appearance={appearance ? Appearance[appearance] : undefined}
    >
      {children}
    </NAlert>
  )
}
